// import PropTypes from "prop-types";
import BasicReactTableWrapper from "../../../shared_components/basic_react_table_wrapper";

class GlobalBreakdownTable extends BasicReactTableWrapper {
}

GlobalBreakdownTable.propTypes = Object.assign({}, BasicReactTableWrapper.propTypes, {
});


export default GlobalBreakdownTable;
